import { message } from "antd";
import { makeAutoObservable, runInAction } from "mobx";
import { GlobalApi } from "./GlobalApi";
import type { FollowSpaceCard, RecentSpaceEntry, UserInfo } from "./GlobalType";

class GlobalModel {
  currentUser: UserInfo | null = null;
  isLoggedIn = false;
  initialized = false;
  recentSpaceEntries: RecentSpaceEntry[] = [];
  followSpaceCards: FollowSpaceCard[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  async init() {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    const hadToken = !!localStorage.getItem("token");
    if (!hadToken) {
      return;
    }
    const user = await GlobalApi.getUserByToken();
    if (user) {
      runInAction(() => {
        this.isLoggedIn = true;
        this.currentUser = user;
      });
      void this.loadRecentSpaces();
      void this.loadFollowSpaces();
    } else {
      runInAction(() => {
        localStorage.removeItem("token");
        this.isLoggedIn = false;
        this.currentUser = null;
        this.recentSpaceEntries = [];
        this.followSpaceCards = [];
      });
      message.warning("登录已过期，请重新登录");
    }
  }

  setLoggedIn(logged: boolean, user: UserInfo | null) {
    this.isLoggedIn = logged;
    this.currentUser = user;
    if (!logged) {
      localStorage.removeItem("token");
      this.recentSpaceEntries = [];
      this.followSpaceCards = [];
    } else {
      void this.loadRecentSpaces();
      void this.loadFollowSpaces();
    }
  }

  async logout() {
    await GlobalApi.logoutApi();
    runInAction(() => {
      this.setLoggedIn(false, null);
    });
  }

  async loadRecentSpaces() {
    if (!this.isLoggedIn) {
      runInAction(() => {
        this.recentSpaceEntries = [];
      });
      return;
    }
    const rows = await GlobalApi.getRecentSpaceVisits();
    runInAction(() => {
      this.recentSpaceEntries = rows;
    });
  }

  async loadFollowSpaces() {
    if (!this.isLoggedIn) {
      runInAction(() => {
        this.followSpaceCards = [];
      });
      return;
    }
    const rows = await GlobalApi.listFollowSpaceCards();
    runInAction(() => {
      this.followSpaceCards = rows;
    });
  }

  async refreshUserFromServer() {
    const user = await GlobalApi.getUserByToken();
    if (user) {
      runInAction(() => {
        this.currentUser = user;
      });
    }
  }
}

export const globalModel = new GlobalModel();
